import React from "react";
import {
  Destinatario,
  DettaglioMisureMerce,
  Mittente,
  Servizio,
  TotaleMerce,
  NotaDimensioneMerce,
  UploadFile,
  Contrassegno,
  MerceADR,
  Assicurazione,
} from "./AgromentiOrdiniForm";

const PortoFranco = ({ configOrder, setMainForm, mainForm, scrollOnBott, formAutomatico, servizioAutomatico }) => {
  return (
    <>
      {configOrder.ritiri_franco.mittente.visible ? (
        <Mittente
          setMainForm={setMainForm}
          mainForm={mainForm}
          oraPronta={configOrder.ritiri_franco.orapronta}
          luogoRitiroVisible={
            configOrder.ritiri_franco.mittente.default_LuogoRitiro
          }
          riferimentoVisible={
            configOrder.ritiri_franco.mittente.riferimento_visible
          }
          readOnly={configOrder.ritiri_franco.mittente.readonly}
          indicatoriConfig={configOrder.ritiri_franco.mittenteindicatori}
          indirizzoCodificatoRitiro={configOrder.ritiri_franco.MittenteDefault}
          formAutomatico={formAutomatico}
        />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.destinatario.visible ? (
        <Destinatario
          setMainForm={setMainForm}
          mainForm={mainForm}
          luogoRitiroVisible={
            configOrder.ritiri_franco.destinatario.default_LuogoRitiro
          }
          riferimentoVisible={
            configOrder.ritiri_franco.destinatario.riferimento_visible
          }
          readOnly={configOrder.ritiri_franco.destinatario.readonly}
          indicatoriConfig={configOrder.ritiri_franco.destinatarioindicatori}
          formAutomatico={formAutomatico}
        />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.servizio.visible ? (
        <Servizio
          setMainForm={setMainForm}
          mainForm={mainForm}
          formautomatico={formAutomatico}
          ServizioAutomatico={servizioAutomatico || formAutomatico?.Servizio || ""}
        />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.dettagliomisuremerce.visible ? (
        <DettaglioMisureMerce setMainForm={setMainForm} mainForm={mainForm} formAutomatico={formAutomatico} />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.totalemerce.visible ? (
        <TotaleMerce setMainForm={setMainForm} mainForm={mainForm} />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.notadimensioni.visible ? (
        <NotaDimensioneMerce setMainForm={setMainForm} mainForm={mainForm} />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.uploadfile.visible ? (
        <UploadFile setMainForm={setMainForm} mainForm={mainForm} />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.contrassegno.visible ? (
        <Contrassegno setMainForm={setMainForm} mainForm={mainForm} scrollOnBott={scrollOnBott} formAutomatico={formAutomatico} />
      ) : (
        <></>
      )}
      {configOrder.ritiri_franco.merceadr.visible ? <MerceADR scrollOnBott={scrollOnBott} mainForm={mainForm} setMainForm={setMainForm} formAutomatico={formAutomatico} /> : <></>}
      {configOrder.ritiri_franco.assicurazione.visible ? (
        <Assicurazione setMainForm={setMainForm} mainForm={mainForm} scrollOnBott={scrollOnBott} />
      ) : (
        <></>
      )}
    </>
  );
};

export default PortoFranco;
